import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';

const VideoModal = ({ open, handleClose }) => {
  return (
    <Dialog
      open={open}
      maxWidth={'xs'}
      fullWidth={true}
      onClose={handleClose}
      aria-labelledby="form-dialog-title2"
    >
      <div className="text-center mb-3">
        <DialogTitle id="form-dialog-title"><h3>Watch video</h3></DialogTitle>
      </div>
      <DialogContent>
        <iframe
          src='https://www.youtube.com/embed/qbnTZCj0ugI'
          allow='autoplay; encrypted-media'
          allowFullScreen={true}
          title='video'
          height='300'
          width='400'
        />
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal;